import React, { useEffect } from "react";
import { Text } from "@mantine/core";
import _ from "lodash";
import FileList from "../fileList";

const ExtraFieldFileInput = ({
  form,
  fieldKey,
  label,
  multiple = false,
  readOnly = false,
  disabled = false,
}) => {
  const name = `extraFieldValues.${fieldKey}`;

  useEffect(() => {
    if (!form) return;
    const raw = _.get(form.values, name);
    if (raw == null) return;
    if (!Array.isArray(raw)) {
      form.setFieldValue(name, [raw]);
    }
  }, [form, name]);

  useEffect(() => {
    if (!form || multiple) return;
    const raw = _.get(form.values, name);
    if (!Array.isArray(raw) || raw.length <= 1) return;
    form.setFieldValue(name, raw.slice(-1));
  }, [form, fieldKey, multiple, name, form?.values?.extraFieldValues]);

  if (!form) return null;

  return (
    <>
      {label ? (
        <Text size="sm" weight={500} mb={4}>
          {label}
        </Text>
      ) : null}
      <FileList
        form={form}
        name={name}
        manageFilesLocally
        disabled={disabled || readOnly}
        uploadLabel={multiple ? "Upload Files" : "Upload File"}
        showNoFilesMessage
      />
    </>
  );
};

export default ExtraFieldFileInput;
